module.exports = __webpack_public_path__ + "8022b370ed29167ebea1a28bac924f9d.svg";